import Vue from "vue";
import Router from "vue-router";
import Home from "../components/home/Home";
import Course from "../components/course/Course";
import CourseDetail from "../components/course/CourseDetail";
import Lesson from "../components/course/Lesson";
import Items from "../components/item/Items";
import ItemDetail from "../components/item/ItemDetail";
import ItemLists from "../components/item/ItemLists";
import Cart from "../components/cart/Cart";
import Payment from "../components/payment/Payment";
import Service from "../components/service/Service";
import ServiceDetail from "../components/service/ServiceDetail";
import ServiceResult from "../components/service/ServiceResult";
import Article from "../components/article/Article";
import ArticleReader from "../components/article/ArticleReader";
import Login from "../components/login/Login";
import SignUp from "../components/login/SignUp";
import ForgotPassword from "../components/login/ForgotPassword";
import Otp from "../components/login/OtpVerify";
import Categories from "../components/categories/Categories";
import ItemCategory from "../components/item/ItemCategory";
import Search from "../components/search/Search";
import WalletFeedback from "../components/feedback/WalletFeeback";
import CoursePayment from "../components/course/CoursePayment";
import Profile from "../components/profile/Profile";
import LuanGiaiTuoi from "../components/luan-giai-tuoi/LuanGiaiTuoi";
import OrderHistory from "../components/history/OrderHistory";
import OrderHistoryDetail from "../components/history/OrderHistoryDetail";
import UpgradeAccount from "../components/account/UpgradeAccount";
import Laso from "../components/history/OrderServiceHistory";
import LasoContent from "../components/history/LasoContent";
import LaSoOrder from '../components/service/LaSoOrder';
import NhaO from '../components/history/NhaO';
import TaiLoc from '../components/history/TaiLoc';
import KhamPha from '../components/kham-pha/Index';
import Lixi from '../components/lixi/Index';
import CaiVanHistory from "../components/history/CaiVanHistory";
import CaiVanContent from "../components/history/CaiVanContent";
import Preview from "../components/payment/Preview";

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: "",
      component: Home
    },
    {
      path: "/course",
      component: Course
    },
    {
      path: "/course/:id",
      component: CourseDetail
    },
    {
      path: "/course-payment",
      component: CoursePayment
    },
    {
      path: "/lesson/:id",
      component: Lesson
    },
    {
      path: "/items",
      meta: { layout: "search-header" },
      component: ItemLists
    },
    {
      path: "/items/category/:category",
      meta: { layout: "search-header" },
      component: Items
    },
    {
      path: "/items/vatpham/:id",
      component: ItemDetail
    },
    {
      path: "/services",
      component: Service
    },
    {
      path: "/services/:id",
      component: ServiceDetail
    },
    {
      path: "/services/result/:id",
      component: ServiceResult
    },
    {
      path: "/cart",
      meta: { layout: "search-header" },
      component: Cart
    },
    {
      path: "/payment",
      meta: { layout: "search-header" },
      component: Payment
    },
    {
      path: "/posts",
      component: Article
    },
    {
      path: "/posts/:id",
      component: ArticleReader
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/signup",
      component: SignUp
    },
    {
      path: "/profile",
      component: Profile
    },
    {
      path: "/forgot_pass",
      component: ForgotPassword
    },
    {
      path: "/otp",
      component: Otp
    },
    {
      path: "/categories",
      meta: { layout: "search-header" },
      component: Categories
    },
    {
      path: "/categories/:id",
      meta: { layout: "search-header" },
      component: ItemCategory,
      props: true
    },
    {
      path: "/search",
      meta: { layout: "search-header" },
      component: Search,
    },
    {
      path: "/wallet_feedback",
      component: WalletFeedback
    },
    {
      path: "/feedback",
      component: WalletFeedback
    },
    {
      path: "/luan-giai-tuoi",
      component: LuanGiaiTuoi
    },
    {
      path: "/order-histories",
      component: OrderHistory
    },
    {
      path: "/order-histories/:id",
      component: OrderHistoryDetail,
      props: true
    },
    {
      path: "/upgrade-account",
      component: UpgradeAccount,
      props: true
    },
    {
      path: "/laso",
      component: Laso
    },
    {
      path: "/laso/:id",
      component: LasoContent
    },
    {
      path: "/order/laso",
      component: LaSoOrder
    },
    {
      path: "/nha_o/content",
      component: NhaO
    },
    {
      path: "/tai_loc/content",
      component: TaiLoc
    },
    {
      path: "/kham-pha",
      component: KhamPha
    },
    {
      path: "/lixi",
      component: Lixi
    },
    {
      path: "/caivan",
      component: CaiVanHistory
    },
    {
      path: "/caivan/:id",
      component: CaiVanContent
    },
    {
      path: "/preview",
      component: Preview
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js